// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { useTranslation } from 'react-i18next';
import DispositionCodes from './dispositionCodes.json';

export function getDispositionCode(code: string = '') {
    const { t } = useTranslation();
    return t(DispositionCodes[code.toUpperCase()] || '');
}